var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showMainList,
              expression: "showMainList"
            }
          ],
          staticClass: "main-content",
          attrs: { type: "primary" }
        },
        [
          _c(
            "fcl-addon-search-bar",
            {
              attrs: { filter: _vm.filter },
              on: { advSearchItemResetCallBack: _vm.toAdvancedQuery }
            },
            [
              _c(
                "template",
                { slot: "operations" },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.inputAllowed_PP,
                          expression: "inputAllowed_PP"
                        }
                      ],
                      attrs: {
                        no: "onEdit",
                        type: "primary",
                        disabled: !this.cpSelectRow
                      },
                      on: {
                        click: function($event) {
                          return _vm.onEdit()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Pricing.Edit")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.deleteAllowed_CP && _vm.isActiveCpTab,
                          expression: "deleteAllowed_CP && isActiveCpTab"
                        }
                      ],
                      attrs: { no: "onDeleteCP", type: "danger" },
                      on: {
                        click: function($event) {
                          return _vm.onDelete_CP()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Pricing.Delete")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isActiveCpTab,
                          expression: "!isActiveCpTab"
                        }
                      ],
                      attrs: { no: "onDeletePP", type: "danger" },
                      on: {
                        click: function($event) {
                          return _vm.onDelete_PP()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Pricing.Delete")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.approveAllowed_PP && !_vm.isActiveCpTab,
                          expression: "approveAllowed_PP && !isActiveCpTab"
                        }
                      ],
                      attrs: { no: "onApprovePP", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.onApprove_PP()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Pricing.Approve")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.inputAllowed_PP && !_vm.isActiveCpTab,
                          expression: "inputAllowed_PP && !isActiveCpTab"
                        }
                      ],
                      attrs: { no: "onAdd", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.onAdd()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Pricing.Add")))]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.inputAllowed_PP && !_vm.isActiveCpTab,
                          expression: "inputAllowed_PP && !isActiveCpTab"
                        }
                      ],
                      attrs: { no: "onDownloadTemplate", type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.onDownloadTemplate()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Pricing.Template")))]
                  ),
                  _c(
                    "el-upload",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.inputAllowed_PP && !_vm.isActiveCpTab,
                          expression: "inputAllowed_PP && !isActiveCpTab"
                        }
                      ],
                      staticStyle: {
                        display: "inline-block",
                        "margin-left": "5px"
                      },
                      attrs: {
                        no: "saveExcelFile",
                        action: _vm.URL.price.priceFclAddon.saveExcelFile,
                        headers: { sessionId: _vm.sessionId },
                        "show-file-list": false,
                        accept: ".xls, .xlsx",
                        "on-success": _vm.uploadExcelSuccess,
                        data: {
                          currentOfficeId: _vm.$store.getters.currentOfficeId
                        }
                      }
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { no: "import", type: "primary" } },
                        [_vm._v(_vm._s(_vm.$t("Pricing.Import")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            2
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _c(
            "el-tabs",
            {
              ref: "tabs",
              staticStyle: { width: "100%" },
              attrs: { type: "card" },
              on: { "tab-click": _vm.handleTabClick },
              model: {
                value: _vm.activeTabName,
                callback: function($$v) {
                  _vm.activeTabName = $$v
                },
                expression: "activeTabName"
              }
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("Pricing.CurrentPrice"),
                    name: "cpList"
                  }
                },
                [
                  _c("fcl-addon-data-grid", {
                    attrs: {
                      "v-if": _vm.activeTabName === "cpList",
                      "config-module": "223101",
                      "show-approve": true,
                      "row-data": _vm.rowCpData,
                      "grid-options": _vm.cpGridOptions
                    },
                    on: { selectRowChange: _vm.selectRowChange }
                  }),
                  _c(
                    "div",
                    {
                      ref: "txtCpRemark",
                      staticStyle: { height: "6%", width: "99%" },
                      on: {
                        dblclick: function($event) {
                          return _vm.onTxtRemarksDoubleClick()
                        }
                      }
                    },
                    [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.txtCpRemarks,
                            expression: "txtCpRemarks"
                          }
                        ],
                        staticStyle: {
                          width: "100%",
                          "margin-left": "10px",
                          height: "100%"
                        },
                        attrs: {
                          disabled: true,
                          title: _vm.$t("Pricing.RemarkAreaToolTip")
                        },
                        domProps: { value: _vm.txtCpRemarks },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.txtCpRemarks = $event.target.value
                          }
                        }
                      })
                    ]
                  )
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("Pricing.PendingPrice"),
                    name: "ppList"
                  }
                },
                [
                  _c("fcl-addon-data-grid", {
                    attrs: {
                      "v-if": _vm.activeTabName === "ppList",
                      "config-module": "223102",
                      "show-approve": false,
                      "show-selection": true,
                      "row-data": _vm.rowPpData,
                      "grid-options": _vm.ppGridOptions
                    },
                    on: { selectRowChange: _vm.selectRowChange }
                  }),
                  _c(
                    "div",
                    {
                      ref: "txtPpRemark",
                      staticStyle: { height: "6%", width: "99%" },
                      on: {
                        dblclick: function($event) {
                          return _vm.onTxtRemarksDoubleClick()
                        }
                      }
                    },
                    [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.txtPpRemarks,
                            expression: "txtPpRemarks"
                          }
                        ],
                        staticStyle: {
                          width: "100%",
                          "margin-left": "10px",
                          height: "100%"
                        },
                        attrs: {
                          no: "txtPpRemarks",
                          disabled: true,
                          title: _vm.$t("Pricing.RemarkAreaToolTip")
                        },
                        domProps: { value: _vm.txtPpRemarks },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.txtPpRemarks = $event.target.value
                          }
                        }
                      })
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("fcl-addon-form", {
        attrs: {
          visible: _vm.fclAddonFormDialog.visible,
          price: _vm.fclAddonFormDialog.ss,
          "is-new": _vm.fclAddonFormDialog.isNew
        },
        on: {
          close: _vm.onShippingScheduleFormDialogClose,
          reload: _vm.toQuery
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }